var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{staticClass:"app-bar",class:{ 'app-bar_borderless': _vm.borderless },attrs:{"app":"","flat":""}},[_c('v-container',[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{attrs:{"height":"32","src":_vm.locale.logo,"contain":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }